var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from 'react-router-dom';
import { AuthCache } from '..';
/**
 * Copied and pasted from the otuvy-qm-mobile project
 * and adapted to add extra functionality for user groups
 */
export var PrivateRoute = function (_a) {
    var Component = _a.component, anyRole = _a.anyGroup, everyRole = _a.everyGroup, rest = __rest(_a, ["component", "anyGroup", "everyGroup"]);
    return (((anyRole && AuthCache.isCurrentUserInAnyGroup(anyRole))
        || (everyRole && AuthCache.isCurrentUserInEveryGroup(everyRole))
        || (!everyRole && !anyRole))
        ?
            (_jsx(Route, __assign({}, rest, { render: function (props) {
                    return _jsx(Component, __assign({}, props));
                } }))) : null);
};
export default PrivateRoute;
